import { Paper, Stack } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Laboratory } from './../../model/LaboratoryTypes';
import classes from './LaboratoryCard.module.css';

export interface LaboratoryCardProps {
  laboratory: Laboratory;
  to: string;
}

export function LaboratoryCard({ laboratory, to }: LaboratoryCardProps) {
  const { name } = laboratory;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="10px">
        <TitleCard title={name} />
      </Stack>
    </Paper>
  );
}
